import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  form: {
    display: "flex",
    alignItems: "center",
    marginTop: 10,
    flexDirection: "column",
    width: "100%",
  },
}));
export default useStyles;
